import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import player from "./modules/player.ts";
Vue.use(Vuex);
var debug = process.env.NODE_ENV !== "production";
var store = new Vuex.Store({
    modules: {
        user: user,
        player: player,
    },
    state: {
        drawer: true,
        rightSidebar: false,
    },
    mutations: {
        setDrawer: function (state, val) { return state.drawer = val; },
        setRightSidebar: function (state, val) { return state.rightSidebar = val; },
        toggleRightSidebar: function (state) { return state.rightSidebar = !state.rightSidebar; },
    },
    strict: process.env.NODE_ENV !== "production"
});
export default store;



//////////////////
// WEBPACK FOOTER
// ./src/store/index.ts
// module id = 68
// module chunks = 0